var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQlIdeasHub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.652,
    height: 40.232,
    viewBox: "0 0 29.652 40.232",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M19.826 3a14.222 14.222 0 0 0-2.964.3 14.8 14.8 0 0 0-6.9 25.579 4.118 4.118 0 0 1 1.4 3.113v4.888a4.247 4.247 0 0 0 4.235 4.235h.593a4.191 4.191 0 0 0 7.284 0h.593A4.247 4.247 0 0 0 28.3 36.88v-4.891a4.107 4.107 0 0 1 1.351-3.089A14.806 14.806 0 0 0 19.826 3zm4.235 33.88h-8.47v-2.118h8.47zm0-4.235h-8.47v-2.118h8.47zm-3.176-11.837v5.484h-2.118v-5.484l-3.875-3.854 1.5-1.5 3.43 3.43 3.43-3.43 1.5 1.5z",
    transform: "translate(-.997 -5.676) translate(-4 2.676)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQlIdeasHub);
export default __webpack_public_path__ + "static/media/ql-ideas-hub.0bc3d5a1c1e512557dcfa527c5ba68ef.svg";
export { ForwardRef as ReactComponent };